;(function (_, $) {
  const couponCodeMutationObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutationRecord) {
      if (mutationRecord.attributeName !== 'class') {
        return;
      }

      if (mutationRecord.target.classList.contains('processing')) {
        $('.coupon-row').addClass('processing').block({
          message: null,
          overlayCSS: {
            background: '#fff',
            opacity: 0.6,
          },
        })
      } else {
        $('.coupon-row').addClass('processing').unblock()
      }
    });
  });

  $('.checkout_coupon').each(function () {
    couponCodeMutationObserver.observe(this, {
      attributes: true,
    })
  })

  $('.woocommerce-checkout')
    .on('click', '#tpk-fake-apply-coupon', function () {
      const val = $('#fake_coupon_code').val();

      $('.tpk-fake-coupon-error').empty();
      const couponCodeField = $('#coupon_code');

      couponCodeField.focus();
      couponCodeField.blur();

      couponCodeField.val(val);

      $('.woocommerce-form-coupon button[name="apply_coupon"]').trigger('click');
    })


  $(document.body)
    .on('update_checkout', function () {
      const error = $('.checkout_coupon .coupon-error-notice');

      if (error.length > 0 && error.html()) {
        $('.tpk-fake-coupon-error').html(error.html());
      }
    })

  let gls_pickup_point;

  $(document.body)
    .on('updated_checkout', function () {
      updateGlsPickupHtml()
    })

  $(document.body)
    .on('change', 'input[name^="shipping_method"]', function () {
      gls_pickup_point = null;
    });


  $(document).ready(function () {
    if ($.fn.selectWoo !== undefined) {
      $('#user_origin_field select').selectWoo()
    }
  });

  const mapElements = $("gls-dpm-dialog");
  if (mapElements.length) {
    mapElements.on('change', (e) => {
      gls_pickup_point = e.detail

      updateGlsPickupHtml()
    })
  }

  const updateGlsPickupHtml = () => {
    if (!gls_pickup_point) {
      return;
    }

    const pickupInfoDiv = $("#tpk-gls-pickup-info");

    pickupInfoDiv.html(`
          <p class="tpk-shipping-box__name">${gls_pickup_point.name}</p>
          <p class="tpk-shipping-box__address">${gls_pickup_point.contact.address}, ${gls_pickup_point.contact.city}, ${gls_pickup_point.contact.postalCode}</p>
      `);

    pickupInfoDiv.show();
  }

})(window, jQuery);